// Карта title для роутов
export const routeTitles: Record<string, string> = {
  // Главные страницы
  'Home': 'Главная',
  'Calendar': 'Календарь событий',
  'EducationPage': 'Образование',
  'About': 'О школе',
  'Howto': 'Как начать',
  'News': 'Новости',
  'NewsPage': 'Новость',
  'NewsArchive': 'Архив новостей',
  'Course': 'Курс',
  'Video': 'Видео',
  'Partners': 'Партнеры',
  'Faq': 'Часто задаваемые вопросы',
  'Accelerator': 'Акселератор',
  'Tutors': 'Тренеры',
  'Teams': 'Команды',
  'HighSchool': 'Высшая школа',
  'Documents': 'Документы',
  'Information': 'Сведения об образовательной организации',
  'InfoBasic': 'Основные сведения',
  'InfoStructure': 'Структура и органы управления',
  'InfoDocs': 'Документы',
  'InfoEdu': 'Образование',
  'InfoEduStandart': 'Образовательные стандарты',
  'InfoEduTutors': 'Руководство. Педагогический состав',
  'InfoLeads': 'Руководство',
  'InfoMaterial': 'Материально-техническое обеспечение',
  'InfoScholarship': 'Стипендии и иные виды материальной поддержки',
  'PaidEdu': 'Платные образовательные услуги',
  'InfoBudget': 'Финансово-хозяйственная деятельность',
  'InfoAntiCorruption': 'Противодействие коррупции',
  'InfoZakupki': 'Вакантные места для приема',
  'InfoAccreditations': 'Международное сотрудничество',
  'Vacant': 'Вакансии',
  'Ovz': 'Доступная среда',
  'InfoInt': 'Международное сотрудничество',
  'Inter': 'Международное сотрудничество',
  'Sitemap': 'Карта сайта',
  'SignIn': 'Вход',
  'SignUp': 'Регистрация',
  'Mentoring': 'Менторство',
  'OfflineNewExport': 'Офлайн-обучение',
  'OnlineOrder': 'Онлайн-заявка',
  'Olympics': 'Олимпиада',
  'Kkt': 'ККТ',
  'OnlineSeminar': 'Онлайн-семинар',
  'FinForGirls': 'Финансы для девушек',
  'Events': 'Событие',

  // Профиль пользователя
  'Profile': 'Личный кабинет',
  'ProfileSettings': 'Настройки профиля',
  'ProfileCompanySettings': 'Настройки компании',
  'SubscribeSettings': 'Настройки подписок',
  'Selection': 'Выбор тренера',
  'Docs': 'Документы',
  'OnlineDocs': 'Онлайн документы',
  'OfflineDocs': 'Офлайн документы',
  'Requests': 'Заявки',
  'OnlineRequests': 'Онлайн заявки',
  'OfflineRequests': 'Офлайн заявки',
  'RegionTeam': 'Региональная команда',
  'RegionTeamForm': 'Форма региональной команды',
  'RegionTeamMembers': 'Участники команды',
  'Ebs': 'ЭБС',
  'Libs': 'Библиотека',
  'Seminars': 'Семинары',
  'SeminarsId': 'Семинар',
  'SeminarStat': 'Статистика семинара',
  'SeminarInvite': 'Приглашение на семинар',
  'Online': 'Онлайн',
  'Test': 'Тест',
  'TutorLibs': 'Библиотека тренера',
  'Notification': 'Уведомления',
  'Recommend': 'Рекомендации',
  'AcceleratorCompany': 'Компания акселератора',
  'AcceleratorDocs': 'Документы акселератора',
  'AcceleratorMember': 'Участники акселератора',
  'AcceleratorProfile': 'Профиль акселератора',
  'MspCompany': 'Компания МСП',
  'MspDocs': 'Документы МСП',
  'MspMember': 'Участники МСП',
  'MspProfile': 'Профиль МСП',
  'ForsageCompany': 'Компания Форсаж',
  'ForsageDocs': 'Документы Форсаж',
  'ForsageMember': 'Участники Форсаж',
  'ForsageProfile': 'Профиль Форсаж',
  'MspForsageOperatorOrders': 'Новые заявки',
  'MspForsageGroups': 'Потоки обучения',
  'EventOrder': 'Заявка на событие',
};

/**
 * Получает title для роута
 * @param routeName - название роута
 * @param params - параметры роута для динамических title
 * @returns title страницы
 */
export function getRouteTitle(routeName: string, params?: any): string {
  // Специальная обработка для динамических роутов
  if (routeName === 'NewsPage' && params?.id) {
    return 'Новость';
  }
  
  if (routeName === 'Course' && params?.program && params?.course) {
    return 'Курс';
  }
  
  if (routeName === 'Video' && params?.course && params?.module && params?.lecture) {
    return 'Видео';
  }
  
  if (routeName === 'Events' && params?.id) {
    return 'Событие';
  }
  
  if (routeName === 'SeminarsId' && params?.id) {
    return 'Семинар';
  }
  
  if (routeName === 'Test' && params?.id) {
    return 'Тест';
  }

  return routeTitles[routeName] || '';
}
